import React from 'react';
import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';
import { RightIcon, DownIcon } from '../../components/icons';

export const MuiTreeView: {
    defaultProps?: ComponentsProps['MuiTreeView'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTreeView'];
    variants?: ComponentsVariants['MuiTreeView'];
} = {
    defaultProps: {
        defaultCollapseIcon: <DownIcon />,
        defaultExpandIcon: <RightIcon />,
    },
    styleOverrides: {},
};

export const MuiTreeItem: {
    defaultProps?: ComponentsProps['MuiTreeItem'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTreeItem'];
    variants?: ComponentsVariants['MuiTreeItem'];
} = {
    styleOverrides: {
        root: {
            '::before': {
                display: 'none',
            },
        },
    },
};
